import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      onLogin(data);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: 'Geist, Arial, sans-serif', background: '#0C1824', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', padding: 40, maxWidth: 400, width: '100%' }} data-testid="admin-login">
        <h1 style={{ fontSize: 22, fontWeight: 600, color: '#0C1824', margin: '0 0 8px', letterSpacing: '-0.02em' }}>Admin</h1>
        <p style={{ fontSize: 14, color: '#637989', margin: '0 0 24px' }}>Sign in to access submissions.</p>

        {error && <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', color: '#B91C1C', padding: '10px 14px', fontSize: 13, marginBottom: 16 }} data-testid="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{ width: '100%', padding: '12px 14px', border: '1px solid #DBE6EC', fontSize: 14, marginBottom: 12, boxSizing: 'border-box' }}
            data-testid="login-email"
          />
          <input
            type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ width: '100%', padding: '12px 14px', border: '1px solid #DBE6EC', fontSize: 14, marginBottom: 20, boxSizing: 'border-box' }}
            data-testid="login-password"
          />
          <button
            type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#0C1824', color: '#fff', fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer', opacity: loading ? 0.6 : 1 }}
            data-testid="login-submit"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
